import { graphqlRequest } from "../graphqlClient";
import type {
  Forecast12MonthCategoryBalanceViewConnection,
  Forecast12MonthCategoryBalanceViewFilterInput,
} from "../models/forecast12MonthCategoryBalanceView";

export interface Forecast12MonthCategoryBalanceViewSortInput {
  field: string;
  order: "Ascending" | "Descending";
}

interface Forecast12MonthCategoryBalanceViewListResponse {
  transactions: {
    forecast12MonthCategoryBalanceViewList: Forecast12MonthCategoryBalanceViewConnection;
  };
}

export async function getForecast12MonthCategoryBalancesGraphql(
  filter?: Forecast12MonthCategoryBalanceViewFilterInput,
  first?: number,
  after?: string,
  sort?: Forecast12MonthCategoryBalanceViewSortInput[],
): Promise<Forecast12MonthCategoryBalanceViewConnection> {
  const query = `
    query Forecast12MonthCategoryBalanceViewList($filter: Forecast12MonthCategoryBalanceViewFilterInput, $first: Int, $after: String, $sort: [Forecast12MonthCategoryBalanceViewSortSortByInput!]) {
      transactions {
        forecast12MonthCategoryBalanceViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              monthKey
              category
              incoming
              outgoing
              netChange
              transactionCount
              averageConfidenceScore
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthCategoryBalanceViewListResponse>(
      query,
      {
        filter,
        first,
        after,
        sort,
      },
    );
  return data.transactions.forecast12MonthCategoryBalanceViewList;
}

interface Forecast12MonthCategoryBalanceViewCountResponse {
  transactions: {
    forecast12MonthCategoryBalanceViewCount: number;
  };
}

export async function getForecast12MonthCategoryBalancesCount(
  filter?: Forecast12MonthCategoryBalanceViewFilterInput,
): Promise<number> {
  const query = `
    query Forecast12MonthCategoryBalanceViewCount($filter: Forecast12MonthCategoryBalanceViewFilterInput) {
      transactions {
        forecast12MonthCategoryBalanceViewCount(filter: $filter)
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthCategoryBalanceViewCountResponse>(
      query,
      {
        filter,
      },
    );
  return data.transactions.forecast12MonthCategoryBalanceViewCount;
}

interface Forecast12MonthCategoryBalanceViewDistinctValuesResponse {
  transactions: {
    forecast12MonthCategoryBalanceViewDistinctValues: string[];
  };
}

export async function getForecast12MonthCategoryBalanceDistinctValues(
  field: string,
): Promise<string[]> {
  const query = `
    query Forecast12MonthCategoryBalanceViewDistinctValues($field: String!) {
      transactions {
        forecast12MonthCategoryBalanceViewDistinctValues(field: $field)
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthCategoryBalanceViewDistinctValuesResponse>(
      query,
      {
        field,
      },
    );
  return data.transactions.forecast12MonthCategoryBalanceViewDistinctValues;
}
